import React from 'react';
import { Link } from 'react-router-dom';

const LINKS = {
  Learn: [
    { label: 'Study Hub', to: '/hub' },
    { label: 'Sign up', to: '/register' },
    { label: 'Log in', to: '/login' },
  ],
  Company: [
    { label: 'About Us', to: '/about' },
    { label: 'Contact', to: '/contact' },
    { label: 'Privacy Policy', to: '/privacy' },
    { label: 'Terms of Use', to: '/terms' },
  ],
};

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__brand">
          <div className="footer__logo">MK<span>Classes</span></div>
          <p className="footer__tagline">Notes, videos, doubts and live classes, all in one place.</p>
        </div>

        {Object.entries(LINKS).map(([group, links]) => (
          <div key={group} className="footer__col">
            <h4 className="footer__col-title">{group}</h4>
            <ul className="footer__col-links">
              {links.map(l => (
                <li key={l.label}><Link to={l.to}>{l.label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="footer__bottom">
        <p>© {new Date().getFullYear()} MK Classes. All rights reserved.</p>
      </div>
    </footer>
  );
}
